<template>
    <section class="auth-page section">
        <div v-if="errorFlags.signInFailed" class="auth-page__alerts">
            <b-alert
                class="ui-alert ui-alert--danger"
                :show="this.errorFlags.signInFailed != ''"
                variant="danger"
                fade
            >
                <span class="ui-alert__message">{{ this.errorFlags.signInFailed }}</span>
            </b-alert>
        </div>
        <div class="auth-card ui-card ui-stack ui-stack--lg">
            <header class="auth-card__header ui-stack ui-stack--sm">
                <p class="auth-card__lead">
                    購入手続きへ進む前に、<br> アルクのメールアドレスIDでログインしてください。
                </p>
            </header>

            <div class="auth-card__cta">
                <a
                    class="ui-button ui-button--outline auth-button"
                    href="#"
                    @click.prevent="trackSigninPageHyperlink('register_from_signinpage_click', pageLinks.alcEowpSignupLink)"
                >アカウントの新規登録はこちら</a>
            </div>

            <form class="auth-form ui-stack ui-stack--md" @submit.prevent="login">
                <p class="auth-form__note">▼アカウントをお持ちの方はこちら▼</p>

                <div class="auth-input-group">
                    <input
                        class="auth-input"
                        :class="controlFieldBG(loginForm.email)"
                        type="text"
                        name="email"
                        placeholder="メールアドレスID"
                        v-model="loginForm.email"
                    />
                </div>

                <div class="auth-input-group">
                    <input
                        class="auth-input"
                        :class="controlFieldBG(loginForm.password)"
                        :type="passwordInputType"
                        name="password"
                        placeholder="パスワード"
                        v-model="loginForm.password"
                    />
                    <button type="button" class="toggle-password" @click="togglePassword()">
                        <img :src="passwordInputType === 'text' ? eyeOpenImg : eyeCloseImg" alt="パスワードを表示" />
                    </button>
                </div>

                <div class="auth-form__actions">
                    <button
                        v-if="!loadingIndicator"
                        class="ui-button ui-button--primary auth-button"
                        type="submit"
                    >ログイン</button>
                    <div v-else class="auth-loading">
                        <img src="/images/eowp/animation/signin-loading.jpg" alt="読み込み中" />
                    </div>
                </div>

                <div class="auth-links">
                    <a
                        href="#"
                        class="auth-link"
                        @click="trackSigninPageHyperlink('password_reset_click', pageLinks.alcEowpForgotPasswordLink)"
                    >パスワードをお忘れの方はこちら（再設定）</a>
                </div>
            </form>

            <footer class="auth-card__footer">
                <p class="auth-browser-note">
                    当ショップの推奨Webブラウザー環境は、Edge、Chrome、Firefox、Safariの各最新版です（Internet Explorerではご利用いただけません）。
                </p>
            </footer>
        </div>
    </section>
</template>
<style src="../../../css/ui-primitives.css"></style>

<style scoped>
.auth-page {
    --auth-header-footer-offset: calc(var(--alc-header-height, 110px) + var(--alc-footer-height, 110px));
    min-height: calc(100vh - var(--auth-header-footer-offset));
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 64px 16px;
    background: var(--neutral-100);
}

@supports (height: 100dvh) {
    .auth-page {
        min-height: calc(100dvh - var(--auth-header-footer-offset));
    }
}

.auth-page__alerts {
    width: 100%;
    max-width: 520px;
    display: grid;
    gap: 12px;
    margin-bottom: 24px;
}

.auth-page__alerts .ui-alert__message {
    white-space: pre-line;
}

.auth-page__alerts .ui-alert {
    padding-right: 20px;
}

.auth-card {
    width: 100%;
    max-width: 520px;
}

.auth-card__header {
    text-align: center;
}

.auth-card__lead {
    margin: 0;
    font-size: 1.15rem;
    font-weight: 600;
    line-height: 1.7;
    color: var(--text-strong);
}

.auth-card__cta,
.auth-form {
    width: 100%;
}

.auth-button {
    width: 100%;
}

.auth-form__note {
    margin: 0;
    font-size: 0.95rem;
    color: var(--text-body);
    text-align: center;
}

.auth-input-group {
    position: relative;
}

.auth-input {
    width: 100%;
    padding: 0.9rem 2.75rem 0.9rem 1rem;
    font-size: 1rem;
    font-weight: 600;
    color: var(--text-strong);
    background: var(--surface-base);
    border: 1px solid var(--neutral-300);
    border-radius: 12px;
    transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.auth-input::placeholder {
    color: var(--text-muted);
}

.auth-input.auth-input--filled,
.auth-input:focus {
    border-color: var(--brand-primary-base);
    box-shadow: 0 0 0 3px rgba(var(--brand-primary-rgb), 0.15);
    outline: none;
}

.auth-form__actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.auth-loading {
    display: flex;
    justify-content: center;
    padding: 0.9rem 0;
}

.auth-loading img {
    width: 50px;
    height: auto;
}

.toggle-password {
    position: absolute;
    top: 50%;
    right: 0.75rem;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 2rem;
    border: none;
    background: transparent;
    cursor: pointer;
    padding: 0;
}

.toggle-password img {
    width: 1.4rem;
    height: auto;
}

.auth-links {
    text-align: center;
    font-size: 0.95rem;
}

.auth-link {
    color: var(--semantic-info-accent);
    text-decoration: underline;
}

.auth-link:hover {
    text-decoration: none;
}

.auth-card__footer {
    text-align: center;
}

.auth-browser-note {
    margin: 0;
    font-size: 0.9rem;
    color: var(--text-subtle);
    line-height: 1.6;
}

@media (max-width: 767px) {
    .auth-page {
        padding: 48px 12px;
    }

    .auth-card__lead {
        font-size: 1.05rem;
    }

    .auth-form__note {
        font-size: 0.9rem;
    }
}

@media (max-width: 575px) {
    .auth-card {
        max-width: 100%;
    }

    .auth-input {
        padding-right: 2.5rem;
    }
}
</style>

<script>
import $ from "jquery";
import { mapActions, mapGetters } from "vuex";
import UserModel from "../../../js/models/UserModel";
import Utils from "../../../js/helpers/Utils";
import DomainSpecific from "../../../js/helpers/DomainSpecific";
import UserEnvironment from "../../../js/helpers/UserEnvironment";
import { BAlert } from "bootstrap-vue";

export default {
    data() {
        return {
            loginForm: {
                email: "",
                password: "",
            },
            errorFlags: {
                signInFailed: "",
                statusCodes: {
                    ERR1: "ネットワークエラー - 認証サーバーへの接続に失敗しました。",
                    ERR5: "「英辞郎 on the WEB Pro」のお申し込みには、アルクのメールアドレスIDとパスワードが必要です。",
                    ERR6: "ログインに失敗しました。\nメールアドレスまたはパスワードを再度ご確認ください。",
                    LOCAL_INVALID_EMAIL: "入力されたメールアドレスの形式が正しくありません。"
                }
            },
            loadingIndicator: false,
            sessions: {
                chosenItem: '',
                pathIntention: ''
            },
            userReference: {
                osName: '',
                browserVersion: '',
                browserDimension: ''
            },
            pageLinks: {
                alcEowpSignupLink: '',
                alcEowpForgotPasswordLink: ''
            },
            passwordInputType: 'password',
            eyeOpenImg: '/images/eowp/eye-open.svg',
            eyeCloseImg: '/images/eowp/eye-close.svg',
        };
    },
    mounted(){
        this.sessions.chosenItem = this.chosenItem;
        this.sessions.pathIntention = this.pathIntention;
    },
    created() {
        this.userClearStates();
        this.ncsClearStates();
        this.csClearStates();
        this.clearAuthorizedUser();
        this.couponClearStates();
        this.init();

        $(document).ready(() => {
            localStorage.removeItem("vuex");
        });
    },
    computed: {
        ...mapGetters({
            pathIntention: 'user/path_intention',
            chosenItem: 'ncs/chosen_item'
        })
    },
    methods: {
        ...mapActions({
            authenticate: "user/authenticate",
            setPathIntention: 'user/setPathIntention',
            userClearStates: 'user/clearStates',
            clearAuthorizedUser: 'user/clearAuthorizedUser',
            setChosenItem: 'ncs/setChosenItem',
            ncsClearStates: 'ncs/clearStates',
            csClearStates: 'cs/clearStates',
            couponClearStates: 'coupon/clearStates',
            trackClickEvent: 'ga/trackClickEvent',
            trackOutboundClickEvent: 'ga/trackOutboundClickEvent'
        }),
        init(){
            let domainSpecific = new DomainSpecific();
            this.pageLinks.alcEowpSignupLink = domainSpecific.value(DomainSpecific.ALC_EOWP_SIGNUP);
            this.pageLinks.alcEowpForgotPasswordLink = domainSpecific.value(DomainSpecific.ALC_EOWP_FORGOTPASS);
        },
        async login() {
            this.trackClickEvent({event: "login_button_click", path: this.$route.path, title: this.$route.meta.title});

            this.loadingIndicator = true;
            this.errorFlags.signInFailed = "";

            if(!Utils.isEmpty(this.loginForm.email) && !this.validEmail(this.loginForm.email)){
                this.errorFlags.signInFailed = this.errorFlags.statusCodes['LOCAL_INVALID_EMAIL'];
                this.loadingIndicator = false;
                return;
            }

            let userEnvironment = new UserEnvironment(navigator, top.window);
            this.userReference.osName = userEnvironment.osVersion();
            this.userReference.browserVersion = userEnvironment.browserVersion();
            this.userReference.browserDimension = userEnvironment.screenDimension();

            let authData = {
                email: this.loginForm.email,
                password: this.loginForm.password,
                osName: this.userReference.osName,
                browserVersion: this.userReference.browserVersion,
                browserDimension: this.userReference.browserDimension
            };

            this.authenticate(authData).then(async (res) => {
                if (res.status == UserModel.STATUS_SUCCESS) {
                    let pathToRedirect = this.sessions.pathIntention;
                    this.setPathIntention('');
                    this.setChosenItem('');
                    setTimeout(() => {
                        if(!Utils.isEmpty(pathToRedirect)){
                            window.location.href = pathToRedirect;
                        } else {
                            window.location.href = "/";
                        }
                    }, 200);
                } else {
                    console.log(res);
                    this.errorFlags.signInFailed = this.errorFlags.statusCodes[res.status_code];
                    this.loadingIndicator = false;
                }
            });
        },
        validEmail(email) {
            let utils = new Utils();
            return utils.verifyEmail(email);
        },
        controlFieldBG(refVal){
            return refVal ? 'auth-input--filled' : '';
        },
        async trackSigninPageHyperlink(eventName, url){
            this.trackOutboundClickEvent({event: eventName, path: this.$route.path, title: this.$route.meta.title, url: url});
        },
        togglePassword() {
            this.passwordInputType = this.passwordInputType === 'password' ? 'text' : 'password';
        },
    },
    components: { BAlert }
};
</script>
